import { useCallback, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import useQueryLinkNavigate from '../../../hooks/useQueryLinkNavigate.js';
import MergedTableHeader from '../../../component/common/dataGrid/MergedTableHeader';
import Main from '../../../component/Main.jsx';
import RegisterModal from './RegisterModal';

import { useDynamicStyle } from '../../../hooks/useDynamicStyle.js';
import { useSubIcon } from '../../../hooks/useSubIcon.js';
import * as Icons from '../../../images/icons/icons_component.js';
import '../../../css/data-grid.css';

const OrgParticipate = () => {

	const { emogcode } = useParams();
	const { returnPage } = useQueryLinkNavigate();

	const [emimemog, setEmimemog] = useState([]);
	const [gateway, setGateway] = useState([]);
	const [ip, setIp] = useState([]);
	const [checkItems, setCheckItems] = useState([]);
	const [isOpen, setIsOpen] = useState(false);
	const [authKey, setAuthKey] = useState('');
	const [clone, setClone] = useState([]);
	const [activeTab, setActiveTab] = useState('nedis');

	const dataHead1 = [['구분', 'GatewayPC 정보', 'GatewayPC 정보', 'GatewayPC 정보', 'GatewayPC 정보', 'GatewayPC 정보'], ['GatewayPC', '시스템OS', 'Physical주소(*)', 'IP주소', '브라우저', '인증키 ']];
	const dataHead2 = [['실시간 가용병상 전달 Gateway PC 공인 IP', '실시간 가용병상 전달 Gateway PC 공인 IP'], ['IP 정보', '수집일시']];
	const dataColumn1 = ['AGENTNAME', 'SYOS', 'PHAD', 'IPAD', 'BRWV', 'SEARCHAUTHKEY'];
	const dataColumn2 = ['AGENTIP', 'AGENTIPDATE'];

	const handleInputChange = (e) => {
		const { name, value, type, checked } = e.target;

		setEmimemog((prev) => ({
			...prev,
			addInfo: {
				...prev.addInfo,
				[name]: type === 'checkbox' ? (checked ? 'Y' : 'N') : value,
			},
		}));
	};

	const handleAllCheck = (checked) => setCheckItems(checked ? [...gateway] : []);

	const handleSingleCheck = (checked, item) => {
		const originalItem = gateway.find((row) => row.SET_SEQ === item.SET_SEQ);
		if (!originalItem) return;

		setCheckItems((prev) =>
			checked
				? [...prev, originalItem]
				: prev.filter((i) => i.SET_SEQ !== item.SET_SEQ)
		);
	};

	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get('/commonapi/agent/getOrgParticipate.do', {
					params: {
						emogcode: emogcode
					}
				});
				setEmimemog(response.data);
			}
			catch (error) {
				console.error('초기 데이터 로딩 중 오류 발생:', error);
			}
		};
		const fetchGate = async () => {
			try {
				const response = await axios.get('/commonapi/agent/getOrgParticipateGrid.do', {
					params: {
						emogcode: emogcode
					}
				});
				setGateway(response.data);
				setClone(response.data);
			} catch (error) {
				console.error('초기 데이터 로딩 중 오류 발생:', error);
			}
		};
		const fetchaddr = async () => {
			try {
				const response = await axios.get('/commonapi/agent/getOrgParticipateIp.do', {
					params: {
						emogcode: emogcode
					}
				});
				setIp(response.data);
			} catch (error) {
				console.error('초기 데이터 로딩 중 오류 발생:', error);
			}
		};
		fetchData();
		fetchGate();
		fetchaddr();
	}, []);

	const singleHeader = !Array.isArray(dataHead1[0]);
	const headerRows = singleHeader ? [dataHead1] : dataHead1;
	const headerRowCount = headerRows.length;
	const colCount = headerRows[0].length;
	const skip = Array.from({ length: headerRowCount }, () => Array(colCount).fill(false));

	const getHeaderSpans = (r, c) => {
		if (skip[r][c]) return null;
		const value = headerRows[r][c];
		let rowspan = 1;
		let colspan = 1;

		// horizontal
		for (let i = c + 1; i < colCount; i++) {
			if (headerRows[r][i] === value) {
				colspan++;
				skip[r][i] = true;
			} else break;
		}

		// vertical
		if (!singleHeader) {
			for (let i = r + 1; i < headerRowCount; i++) {
				let same = true;
				for (let j = 0; j < colspan; j++) {
					if (headerRows[i][c + j] !== value) {
						same = false;
						break;
					}
				}
				if (same) {
					for (let j = 0; j < colspan; j++) skip[i][c + j] = true;
					rowspan++;
				} else break;
			}
		}

		return { rowspan, colspan, value };
	};

	/* ───────────────────────────────────────────────────  유틸: 행 병합  ─── */
	const computeRowSpans = useCallback((list) => {
		const mergeKey = '';
		const spans = list.map(() => ({}));

		let prev = null;
		let start = 0;
		let cnt = 1;

		list.forEach((row, idx) => {
			const cur = row[mergeKey];
			if (cur === prev) {
				spans[start][mergeKey] += 1;
				spans[idx][mergeKey] = 0;
				cnt += 1;
			} else {
				spans[idx][mergeKey] = 1;
				start = idx;
				cnt = 1;
				prev = cur;
			}
		});

		// merge 아닌 컬럼 기본 1
		list.forEach((_, i) => {
			dataColumn1.forEach((k) => {
				if (!(k in spans[i])) spans[i][k] = 1;
			});
		});
		return spans;
	}, []);

	const rowSpans = useMemo(() => computeRowSpans(gateway), [gateway, computeRowSpans]);

	const handleCellChange = (rowIdx, colKey, value) => {
		setGateway((prev) => {
			const next = [...prev];
			const currentRow = next[rowIdx];

			if (currentRow[colKey] === value) return prev;

			let state = currentRow.stateRows;

			if (state !== 'inserted') {
				state = 'updated';
			}

			const updatedRow = {
				...currentRow,
				[colKey]: value,
				stateRows: state,
			};

			next[rowIdx] = updatedRow;
			return next;
		});
	};

	const renderCell = (row, rowIdx, colKey) => {
		const span = rowSpans[rowIdx][colKey];
		if (span === 0) return null;
		const value = row[colKey] ?? '';

		// 텍스트 필드
		if (['AGENTNAME', 'SYOS', 'PHAD', 'IPAD', 'BRWV'].includes(colKey)) {
			return (
				<td key={colKey} rowSpan={span}>
					<input
						type='text'
						value={value}
						className={`h-7 bg-transparent text-center`}
						onChange={(e) => handleCellChange(rowIdx, colKey, e.target.value)}
					/>
				</td>
			);
		}
		return (
			<td key={colKey} rowSpan={span} className='justify-items-center'>
				<button className='search_btn bg_ho_primary' onClick={() => showAuthkey(row.AUTHKEY)}>
					조회
				</button>
			</td>
		);
	};

	const add = () => {
		const newRow = {
			SET_SEQ: Date.now(),
			state: 'created'
		};
		setGateway((prevData) => [...prevData, newRow]);
	};

	const cancel = async () => {
		const params = new URLSearchParams();
		params.append('deleteArray', JSON.stringify(checkItems));
		params.append('emogcode', emogcode);
		try {
			const response = await axios.post('/commonapi/agent/deleteAgentGrid.do', params, {
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
			});
			const json = response.data;

			if (!json.hasError) {
				alert('삭제되었습니다.');
			} else {
				alert('삭제 중 오류가 발생했습니다.');
			}
		} catch (error) {
			alert('서버 통신 중 오류가 발생했습니다.');
		}
	};

	const showAuthkey = (key) => {
		setAuthKey(key);
		setIsOpen(true);
	};

	const copyToClipboard = () => {
		navigator.clipboard.writeText(authKey).then(() => {
			alert('인증키를 클립보드에 복사하였습니다.');
		});
	};

	const save = async () => {
		const data = emimemog.addInfo;

		if (data.ADDRTRGB === '1' && (!data.ADDRTRCC || data.ADDRTRCC === 'undefined')) {
			alert('전송주기가 자동인 경우 전송주기(초단위)를 입력해주세요.');
			return false;
		}

		if (data.ADDRTRGB === '1' && data.ADDRTRCC > 172800 && (!data.ADDRTRET || data.ADDRTRET === 'undefined')) {
			alert('전송주기가 172800초를 초과하는 경우 사유를 입력해주세요.');
			return false;
		}

		if (data.ADDRTRGB === '3' && (!data.ADDRTRET || data.ADDRTRET === 'undefined')) {
			alert('전송주기가 기타인 경우 기타내용을 입력해주세요.');
			return false;
		}

		if (data.EMOGPRJT === 'Y' && (!data.PRJTSTDT || data.PRJTSTDT === 'undefined')) {
			alert('표준입력체계 사업참여일을 입력해주세요.');
			return false;
		}

		if (data.EMOGSTRM === 'Y' && (!data.STRMSTDT || data.STRMSTDT === 'undefined')) {
			alert('외상 사업참여일을 입력해주세요.');
			return false;
		}

		if (data.EMOGSMTM === 'Y' && (!data.SMTMSTDT || data.SMTMSTDT === 'undefined')) {
			alert('중증질환수용가능정보 사업참여일을 입력해주세요.');
			return false;
		}

		if (data.EMOGRTBD === 'Y' && (!data.RTBDSTDT || data.RTBDSTDT === 'undefined')) {
			alert('실시간 병상정보 사업참여일을 입력해주세요.');
			return false;
		}

		if (data.EMOGSEID === 'Y' && (!data.SEIDSTDT || data.SEIDSTDT === 'undefined')) {
			alert('순환당직 사업참여일을 입력해주세요.');
			return false;
		}

		if (data.EMOGTOXU === 'Y' && (!data.TOXUSTDT || data.TOXUSTDT === 'undefined')) {
			alert('독성정보 사업참여일을 입력해주세요.');
			return false;
		}

		if (data.EMOGKTAS === 'Y' && (!data.KTASSTDT || data.KTASSTDT === 'undefined')) {
			alert('KTAS 전송 참여일을 입력해주세요.');
			return false;
		}

		if (data.ADDRTRGB !== '1') {
			data.ADDRTRCC = '';
		}

		if (data.ADDRTRGB !== '3' && !(data.ADDRTRGB === '1' && data.ADDRTRCC > 172800)) {
			data.ADDRTRET = '';
		}

		var regex = /[^0-9]/g;
		data.PRJTSTDT = data.PRJTSTDT?.replace(regex, '') ?? '';
		data.STRMSTDT = data.STRMSTDT?.replace(regex, '') ?? '';
		data.SMTMSTDT = data.SMTMSTDT?.replace(regex, '') ?? '';
		data.RTBDSTDT = data.RTBDSTDT?.replace(regex, '') ?? '';
		data.SEIDSTDT = data.SEIDSTDT?.replace(regex, '') ?? '';
		data.TOXUSTDT = data.TOXUSTDT?.replace(regex, '') ?? '';
		data.KTASSTDT = data.KTASSTDT?.replace(regex, '') ?? '';

		if (data.EMOGSTRM === 'N') {
			data.STRMSTDT = '';
		}

		const invalidIndex = gateway.findIndex((row) => {
			const isModified = row.stateRows === 'inserted' || row.stateRows === 'updated';
			const isPhadEmpty = !row.PHAD || row.PHAD.trim() === '';

			return isModified && isPhadEmpty;
		});

		if (invalidIndex !== -1) {
			alert(`${invalidIndex + 1}번째 행의 Physical주소가 미입력 되었습니다.`);
			return false;
		}

		const params = new URLSearchParams();

		// URLSearchParams는 null/undefined를 문자열 'null'/'undefined'로 직렬화하므로
		// 그대로 보내면 DB에 'null' 이라는 문자열이 저장된다. 빈 문자열로 치환해서 전송한다.
		Object.keys(data).forEach(key => {
			const value = data[key];
			params.append(key.toLowerCase(), (value === null || value === undefined || value === 'undefined') ? '' : value);
		});

		params.append('gatewaypc', JSON.stringify(gateway));

		try {
			const response = await axios.post('/commonapi/agent/saveParticipateInfo.do', params, {
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
			});
			const json = response.data;

			if (json.hasError) {
				if (json.status !== 'session_timeout') {
					alert(json.resultMessage || json._result_message);
				}
			} else {
				alert(json.resultMessage || json._result_message);
				// window.location.reload();
			}
		} catch (error) {
			const errorData = error.response?.data;
			if (errorData) {
				alert(errorData.resultMessage || errorData._result_message);
			} else {
				alert('서버 통신 중 오류가 발생했습니다.');
			}
		}
	}

	const j001andj002 = (localStorage.getItem('userAuth') === 'J001' || localStorage.getItem('userAuth') === 'J002') ? true : false;
	const excludedCodes = ['G1600006', 'G2200032', 'G2700006', 'G2800019'];
	const isValid = !excludedCodes.includes(emimemog.addInfo?.EMOGCODE);

	const styles = {
		overlay: {
			position: 'fixed',
			top: 0,
			left: 0,
			width: '100vw',
			height: '100vh',
			backgroundColor: 'rgba(0, 0, 0, 0.7)',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			zIndex: 9999,
		},
		modal: {
			backgroundColor: 'white',
			padding: '30px',
			borderRadius: '12px',
			width: '350px',
			position: 'relative',
			textAlign: 'center',
			boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
		},
		closeBtn: {
			position: 'absolute',
			top: '10px',
			right: '15px',
			background: 'none',
			border: 'none',
			fontSize: '24px',
			cursor: 'pointer',
			color: '#999',
		},
		keyBox: {
			backgroundColor: '#f8f9fa',
			padding: '15px',
			margin: '20px 0',
			borderRadius: '6px',
			border: '1px solid #eee',
			wordBreak: 'break-all',
			fontFamily: 'monospace',
			fontWeight: 'bold',
			color: '#333',
		},
		copyBtn: {
			width: '100%',
			padding: '12px',
			backgroundColor: '#007bff',
			color: 'white',
			border: 'none',
			borderRadius: '6px',
			cursor: 'pointer',
			fontSize: '16px',
		}
	};

	useEffect(() => {
		if (emimemog.addInfo?.EMOGSEID === 'Y' &&
			(!emimemog.addInfo?.SEIDSTDT || emimemog.addInfo?.SEIDSTDT === 'undefined')) {

			const today = new Date().toISOString().split('T')[0];
			setEmimemog(prev => ({
				...prev,
				addInfo: { ...prev.addInfo, SEIDSTDT: today }
			}));
		}

		if (emimemog.addInfo?.EMOGSEID === '') {
			setEmimemog(prev => ({
				...prev,
				addInfo: { ...prev.addInfo, SEIDSTDT: '' }
			}));
		}
	}, [emimemog.addInfo?.EMOGSEID, emimemog.addInfo?.SEIDSTDT]);

	const showEgenTab = ['A', 'C', 'D', 'E'].includes(emimemog.addInfo?.EMOGGRDC);

	const tabConfig = [
		{ id: 'nedis', label: '표준등록체계', condition: emimemog.addInfo?.EMOGPRJT === 'Y', dataField: 'urdbedis' },
		{ id: 'trauma', label: '외상등록체계', condition: emimemog.addInfo?.EMOGSTRM === 'Y', dataField: 'urdbstrm' },
		// { id: 'disease', label: '중증질환담당', condition: emimemog.addInfo?.EMOGSMTM === 'Y', dataField: 'urdbsmtm' },
		// { id: 'bed', label: '실시간병상담당', condition: emimemog.addInfo?.EMOGRTBD === 'Y', dataField: 'urdbrtbd' },
		// { id: 'egen', label: '응급의료기관평가', condition: showEgenTab, dataField: 'urdbpyga' },
		// { id: 'toxu', label: '독성정보참여사업', condition: emimemog.addInfo?.EMOGTOXU === 'Y', dataField: 'urdbtoxu' },
		// { id: 'hotline', label: '전원핫라인 담당', condition: true, dataField: 'urdbhtln' },
	];

	// 필터링된 데이터 계산 (성능을 위해 useMemo 권장)
	const filteredData = useMemo(() => {
		const setting = tabConfig.find(t => t.id === activeTab);
		return setting ? emimemog.telInfoList?.filter(item => item[setting.dataField] === 'Y') : [];
	}, [activeTab, emimemog.telInfoList]);

	const [isModalOpen, setIsModalOpen] = useState({
		modalState: false,
		urdbemcd: '',
		urdbseqn: '',
		urdbtype: ''
	});

	const [updateParams, setUpdateParams] = useState({
		urdbemcd: '',
		urdbseqn: '',
		urdbtype: ''
	})

	const modalOpen = (emogcode, type, seq) => {
		setIsModalOpen(prev => ({
			...prev,
			modalState: true,
			urdbemcd: emogcode,
			urdbseqn: seq,
			urdbtype: type
		}));
	}
	const modalClose = () => {
		setIsModalOpen(prev => ({
			...prev,
			modalState: false,
			urdbemcd: '',
			urdbseqn: '',
			urdbtype: ''
		}));
	}

	const cellCilck = (emogcode, type, seq) => {
		setUpdateParams(prev => ({
			...prev,
			urdbemcd: emogcode,
			urdbseqn: seq,
			urdbtype: type,
		}));
		modalOpen(emogcode, type, seq);
	}

	const selectUrdbType = (id) => {
		const typeMap = {
			nedis: 'TYPEA',
			trauma: 'TYPEA',
			disease: 'TYPEB',
			bed: 'TYPEC',
			duty: 'TYPED',
			toxu: 'TYPEE',
			egen: 'TYPEG',
			hotline: 'TYPEH',
		};
		return typeMap[id] || '';
	};

	const LogListPopup = (emogcode) => {
		const senData = {
			code: emogcode
		};
		localStorage.setItem('telLogCode', JSON.stringify(senData));
		let popup = null;
		popup = window.open('/popup/user_tel_log_popup', '팝업', 'scrollbars=0, resizable=0, width=1200, height=500, top=30, left=30');
	}

	// Dynamic Style Hook
	const { backColor, fontColor, primaryBackColor, lightBorderShadowInColor, primaryShadowColor } = useDynamicStyle();
	// icon list
	const { EmptyIcon } = useSubIcon();

	return (
		<Main>
			<RegisterModal
				isModalOpen={isModalOpen}
				modalClose={modalClose}
				updateParams={updateParams}
			/>
			<div className='flex flex-col flex-grow min-h-0 pr-1 overflow-auto'>
				<div className='com-search'>
					{isOpen && (
						<div style={styles.overlay} onClick={() => setIsOpen(false)}>
							<div style={styles.modal} onClick={(e) => e.stopPropagation()}>
								<button style={styles.closeBtn} onClick={() => setIsOpen(false)}>
									&times;
								</button>

								<h3 className='mb-2'>GatewayPC 인증키</h3>
								<p className='text-sm co_dark'>아래 키를 복사하여 사용하세요.</p>

								<div style={styles.keyBox}>
									{authKey}
								</div>

								<button style={styles.copyBtn} onClick={copyToClipboard}>
									클립보드에 복사
								</button>
							</div>
						</div>
					)}
					<table>
						<colgroup>
							<col width='16%' />
							<col width='14%' />
							<col width='14%' />
							<col width='14%' />
							<col width='14%' />
							<col width='14%' />
							<col width='14%' />
						</colgroup>
						<tbody>
							{isValid ?
								<>
									<tr>
										<th>의료기관명</th>
										<td colSpan={7}>{emimemog.addInfo?.EMOGDESC}</td>
									</tr>
									<tr>
										<th>관할지원센터</th>
										<td colSpan={2}>{emimemog.addInfo?.INFONAME}</td>
										<th>NEDIS 데이터형</th>
										<td>
											<p>
												<select id='EMOGITCD' name='EMOGITCD' value={emimemog.addInfo?.EMOGITCD} onChange={handleInputChange}>
													<option value=''>NEDIS 데이터형</option>
													<option value='1'>센터형</option>
													<option value='2'>기관형</option>
												</select>
											</p>
										</td>
										<th>전송주기</th>
										<td>
											<div>
												<select id='ADDRTRGB' name='ADDRTRGB' value={emimemog.addInfo?.ADDRTRGB} onChange={handleInputChange}>
													<option value=''>전송구분</option>
													<option value='1'>자동</option>
													<option value='2'>수동</option>
													<option value='3'>기타</option>
												</select>
												{emimemog.addInfo?.ADDRTRGB === '1' && (
													<input type='text' id='ADDRTRCC' name='ADDRTRCC' placeholder='전송 주기(초단위)를 입력해주세요.' value={emimemog.addInfo?.ADDRTRCC !== 'undefined' ? emimemog.addInfo?.ADDRTRCC : '전송 주기(초단위)를 입력해주세요.'} maxLength={10} onChange={handleInputChange} />
												)}
												{(emimemog.addInfo?.ADDRTRGB === '3' || Number(emimemog.addInfo?.ADDRTRCC) > 172800) && (
													<input type='text' id='ADDRTRET' name='ADDRTRET' placeholder='기타 내용 또는 172,800초 초과 사유를 입력해주세요.' value={emimemog.addInfo?.ADDRTRET !== 'undefined' ? emimemog.addInfo?.ADDRTRET : '기탕 내용 또는 172,800초 초과 사유를 입력해주세요.'} maxLength={45} onChange={handleInputChange} />
												)}
											</div>
										</td>
									</tr>
								</>
								: <></>}
							<tr>
								<td colSpan={7}>
									<div className='data_grid_container header_st_odd'>
										<table>
											<colgroup>
												<col width='14%' />
												<col width='14%' />
												<col width='14%' />
												<col width='14%' />
												<col width='14%' />
												<col width='14%' />
												<col width='14%' />
											</colgroup>
											<tbody>
												<tr>
													<th>구분</th>
													<th>표준등록체계</th>
													<th>외상</th>
													<th>중증질환수용가능정보</th>
													<th>실시간 병상정보</th>
													<th>순환당직</th>
													<th>독성정보</th>
												</tr>
												<tr>
													<th>차수</th>
													<td>
														{(j001andj002 && isValid) ?
															<select id='EMOGPRJT' name='EMOGPRJT' value={emimemog.addInfo?.EMOGPRJT} onChange={handleInputChange}>
																<option value=''>미참여</option>
																<option value='Y'>참여</option>
															</select>
															:
															<>
																<input id='EMOGPRJT' type='hidden' name='EMOGPRJT' value={emimemog.addInfo?.EMOGPRJT === 'Y' ? 'Y' : ''} />
																<p>{emimemog.addInfo?.EMOGPRJT === 'Y' ? '참여' : '미참여'}</p>
															</>
														}
													</td>
													<td>
														{(j001andj002 && isValid) ?
															<select id='EMOGSTRM' name='EMOGSTRM' value={emimemog.addInfo?.EMOGSTRM} onChange={handleInputChange}>
																<option value=''>미참여</option>
																<option value='Y'>참여</option>
															</select>
															:
															<>
																<input id='EMOGSTRM' type='hidden' name='EMOGSTRM' value={emimemog.addInfo?.EMOGSTRM === 'Y' ? 'Y' : ''} />
																<p>{emimemog.addInfo?.EMOGSTRM === 'Y' ? '참여' : '미참여'}</p>
															</>
														}
													</td>
													<td>
														{(j001andj002 && isValid) ?
															<select id='EMOGSMTM' name='EMOGSMTM' value={emimemog.addInfo?.EMOGSMTM} onChange={handleInputChange}>
																<option value=''>미참여</option>
																<option value='Y'>참여</option>
															</select>
															:
															<>
																<input id='EMOGSMTM' type='hidden' name='EMOGSMTM' value={emimemog.addInfo?.EMOGSMTM === 'Y' ? 'Y' : ''} />
																<p>{emimemog.addInfo?.EMOGSMTM === 'Y' ? '참여' : '미참여'}</p>
															</>
														}
													</td>
													<td>
														{(j001andj002 && isValid) ?
															<select id='EMOGRTBD' name='EMOGRTBD' value={emimemog.addInfo?.EMOGRTBD} onChange={handleInputChange}>
																<option value=''>미참여</option>
																<option value='Y'>참여</option>
															</select>
															:
															<>
																<input id='EMOGRTBD' type='hidden' name='EMOGRTBD' value={emimemog.addInfo?.EMOGRTBD === 'Y' ? 'Y' : ''} />
																<p>{emimemog.addInfo?.EMOGRTBD === 'Y' ? '참여' : '미참여'}</p>
															</>
														}
													</td>
													<td>
														{(j001andj002 && isValid) ?
															<select id='EMOGSEID' name='EMOGSEID' value={emimemog.addInfo?.EMOGSEID} onChange={handleInputChange}>
																<option value=''>미참여</option>
																<option value='Y'>참여</option>
															</select>
															:
															<>
																<input id='EMOGSEID' type='hidden' name='EMOGSEID' value={emimemog.addInfo?.EMOGSEID === 'Y' ? 'Y' : ''} />
																<p>{emimemog.addInfo?.EMOGSEID === 'Y' ? '참여' : '미참여'}</p>
															</>
														}
													</td>
													<td>
														{j001andj002 ?
															<select id='EMOGTOXU' name='EMOGTOXU' value={emimemog.addInfo?.EMOGTOXU} onChange={handleInputChange}>
																<option value=''>미참여</option>
																<option value='Y'>참여</option>
															</select>
															:
															<>
																<input id='EMOGTOXU' type='hidden' name='EMOGTOXU' value={emimemog.addInfo?.EMOGTOXU === 'Y' ? 'Y' : ''} />
																<p>{emimemog.addInfo?.EMOGTOXU === 'Y' ? '참여' : '미참여'}</p>
															</>
														}
													</td>
												</tr>
												<tr>
													<th>사업참여일</th>
													<td><input type='date' id='PRJTSTDT' name='PRJTSTDT' defaultValue={emimemog.addInfo?.PRJTSTDT} readOnly={!(j001andj002 && isValid)} onChange={handleInputChange} /></td>
													<td><input type='date' id='STRMSTDT' name='STRMSTDT' defaultValue={emimemog.addInfo?.STRMSTDT} readOnly={!(j001andj002 && isValid)} onChange={handleInputChange} /></td>
													<td><input type='date' id='SMTMSTDT' name='SMTMSTDT' defaultValue={emimemog.addInfo?.SMTMSTDT} readOnly={!(j001andj002 && isValid)} onChange={handleInputChange} /></td>
													<td><input type='date' id='RTBDSTDT' name='RTBDSTDT' defaultValue={emimemog.addInfo?.RTBDSTDT} readOnly={!(j001andj002 && isValid)} onChange={handleInputChange} /></td>
													<td><input type='date' id='SEIDSTDT' name='SEIDSTDT' value={(emimemog.addInfo?.EMOGSEID === 'Y' && (!emimemog.addInfo?.SEIDSTDT || emimemog.addInfo?.SEIDSTDT === 'undefined')) ? new Date().toISOString().split('T')[0] : (emimemog.addInfo?.SEIDSTDT || '')} readOnly={!(j001andj002 && isValid)} onChange={handleInputChange} /></td>
													<td><input type='date' id='TOXUSTDT' name='TOXUSTDT' defaultValue={emimemog.addInfo?.TOXUSTDT} readOnly={!(j001andj002 && isValid)} onChange={handleInputChange} /></td>
												</tr>
											</tbody>
										</table>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				{isValid ?
					<div className='com-search mt-2'>
						<table>
							<colgroup>
								<col width='16%' />
								<col width='84%' />
							</colgroup>
							<tbody>
								<tr>
									<th>Gateway PC 정보</th>
									<td>
										<div className='flex flex-col gap-2'>
											<div className='flex justify-between items-center'>
												<p className='co_gray ml-1'>* Physical주소 예시: 00-00-00-00-00-00 / IP 주소 예시: 000.000.000.000</p>
												<div className='flex gap-1'>
													<button onClick={add} className='search_btn bg_st_primary'><Icons.AddCircle16w />추가</button>
													{(emimemog.orgNamModifyAuth && emimemog.hasModifyAuth) ?
														<button onClick={cancel} className='search_btn bg_tr_primary'><Icons.DeleteCircle16w />삭제</button>
														:
														<></>
													}
												</div>
											</div>
											<div>
												<div className='data_grid_container header_st_odd overflow-y-scroll' style={{ maxHeight: '12rem' }}>
													<table>
														<thead>
															{headerRows.map((row, rIdx) => (
																<tr key={rIdx}>
																	{rIdx === 0 && (
																		<th rowSpan={headerRowCount}>
																			<div className='flex justify-center'>
																				{gateway.length > 0 && checkItems.length === gateway.length ?
																					<Icons.CheckOk className='cursor-pointer' onClick={() => handleAllCheck(false)} />
																					:
																					<Icons.CheckNon className='cursor-pointer' onClick={() => handleAllCheck(true)} />
																				}
																			</div>
																		</th>
																	)}
																	{row.map((col, cIdx) => {
																		const span = getHeaderSpans(rIdx, cIdx);
																		if (!span) return null;
																		const { rowspan, colspan, value } = span;
																		return (
																			<th key={`${rIdx}-${cIdx}`} rowSpan={rowspan} colSpan={colspan}>
																				{value}
																			</th>
																		);
																	})}
																</tr>
															))}
														</thead>
														<tbody>
															{gateway.map((row, rowIdx) => {
																const isChecked = checkItems.some((i) => i.SET_SEQ === row.SET_SEQ);
																return (
																	<tr key={row.SET_SEQ || rowIdx}>
																		<td>
																			<div className='flex justify-center'>
																				{isChecked ?
																					<Icons.CheckOk className='cursor-pointer' onClick={() => handleSingleCheck(false, row)} />
																					:
																					<Icons.CheckNon className='cursor-pointer' onClick={() => handleSingleCheck(true, row)} />
																				}
																			</div>
																		</td>
																		{dataColumn1.map((colKey) => renderCell(row, rowIdx, colKey))}
																	</tr>
																);
															})}
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</td>
								</tr>
								<tr>
									<th>데이터 미전송 알림설정<br /> (Agent PC 점검/경고)</th>
									<td>
										<hr className='border-t-1 mr-1-1' />
										<div className='data_grid_container header_st_odd mr-1-1'>
											<table>
												<colgroup>
													<col width='16%' />
													<col width='16%' />
													<col width='16%' />
													<col width='16%' />
													<col width='16%' />
													<col width='16%' />
												</colgroup>
												<tbody>
													<tr>
														<th>전송점검알림</th>
														<td>
															<div className='flex gap-2 justify-center'>
																<div className='flex gap-1'>
																	<label htmlFor='addrstyn_y'>예</label>
																	<input type='radio' id='addrstyn_y' name='ADDRSTYN' value='Y' checked={emimemog.addInfo?.ADDRSTYN === 'Y'} onChange={handleInputChange} />
																</div>
																<div className='flex gap-1'>
																	<label htmlFor='addrstyn_n'>아니요</label>
																	<input type='radio' id='addrstyn_n' name='ADDRSTYN' value='N' checked={emimemog.addInfo?.ADDRSTYN === 'N'} onChange={handleInputChange} />
																</div>
															</div>
														</td>
														<th>전송점검설정</th>
														<td>
															<select id='ADDRSTDT' name='ADDRSTDT' value={emimemog.addInfo?.ADDRSTDT} onChange={handleInputChange}>
																<option value=''>없음</option>
																{Array.from({ length: 24 }, (_, i) => (i + 1) * 60).map((item) => {
																	const hour = Math.floor(item / 60);
																	return (
																		<option key={item} value={item}>
																			{hour}시간
																		</option>
																	);
																})}
															</select>
														</td>
														<th>전송점검알림구분</th>
														<td>
															<input type='checkbox' id='addrsmyn' name='ADDRSMYN' checked={emimemog.addInfo?.ADDRSMYN === 'Y'} onChange={handleInputChange} />
															<label htmlFor='addrsmyn'>SMS문자</label>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</td>
								</tr>
								<tr>
									<th>실시간 가용병상정보<br />IP 수집 정보
									</th>
									<td>
										<div className='data_grid_container header_st_odd overflow-y-scroll' style={{ maxHeight: '11rem' }}>
											<table>
												<MergedTableHeader
													headers={dataHead2}
													textCenter={true}
												/>
												<tbody>
													{ip?.map((item, rowIndex) => {
														return (
															<tr key={rowIndex}>
																{dataColumn2.map((col, colIndex) => {
																	return (
																		<td key={colIndex}>
																			{item[col]}
																		</td>
																	);

																})}
															</tr>
														)
													})
													}
												</tbody>
											</table>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					:
					<></>}
				{(emimemog.userPermissions?.USERTELI === 'Y' || emimemog.viewSelfYN === 'N') ?
					<div className='my-5 ml-1'>
						<h4 className={fontColor}>▶ 담당자 연락처 정보</h4>
						<div className='flex w-full items-center justify-between'>
							<div className='tab_wrapper'>
								{tabConfig.map(tab => {
									const selected = activeTab === tab.id
									const selectedStyle = primaryBackColor + ' tab_select'
									return (
										tab.condition && (
											<button key={tab.id} className={`tab_title ${backColor} ${fontColor} ${lightBorderShadowInColor} ${primaryShadowColor} ${selected && selectedStyle}`}
												onClick={() => setActiveTab(tab.id)}>{tab.label}
											</button>
										)
									)
								})}
							</div>
							<div className='flex gap-2'>
								{activeTab === 'hotline' && (
									<button className='comm_btn bg_ho_primary' onClick={() => LogListPopup(emogcode)}>이력</button>
								)}
								<button className='comm_btn bg_st_primary' onClick={() => cellCilck(emogcode, selectUrdbType(activeTab), '')}>연락처 등록</button>
							</div>
						</div>
						<div className='com-search data_grid_container header_st_odd'>
							<table>
								<colgroup>
									<col width='10%' />
									<col width='10%' />
									<col width='10%' />
									<col width='10%' />
									<col width='10%' />
									<col width='10%' />
									<col width='10%' />
									<col width='10%' />
									<col width='10%' />
								</colgroup>
								<thead>
									<tr>
										<th className='text-center'>업무구분</th>
										<th className='text-center'>성명</th>
										<th className='text-center'>근무부서</th>
										<th className='text-center'>직위</th>
										<th className='text-center'>연락처</th>
										<th className='text-center'>핸드폰</th>
										<th className='text-center'>이메일</th>
										<th className='text-center'>알림여부</th>
										{activeTab === 'hotline' &&
											<th className='text-center'>업무시작일</th>
										}
										<th className='text-center'>수정일시</th>
									</tr>
								</thead>
								<tbody>
									{filteredData.length === 0 ? (
										<tr>
											<td colSpan={1000} className='empty_box'>
												<span className='data_empty'>
														{EmptyIcon}해당하는 데이터가 없습니다.
												</span>
											</td>
										</tr>
									) : (
										filteredData.map((item, index) => {
											return (
												<tr key={item.urdbseqn || index} className='ho_primary_h'>
													<td>{item.urdbtype}</td>
													<td className='show_tel_info cursor-pointer underline ho_color_h'
														title='연락처정보 상세보기'
														onClick={() => {
															cellCilck(item.urdbemcd, selectUrdbType(activeTab), item.urdbseqn)
														}}>
														{item.urdbname}
													</td>
													<td>{item.urdbdept}</td>
													<td>{item.urdbgrde || '-'}</td>
													<td>{item.urdbtel1}</td>
													<td>{item.urdbcell}</td>
													<td>{item.urdbmail || '-'}</td>
													<td>{item.urdbsdma || '-'}</td>
													{activeTab === 'hotline' &&
														<td>{item.urdbwkstdt || '-'}</td>
													}
													<td>{item.urdbwkdt}&nbsp;{item.urdbwktm}</td>
												</tr>
											);
										})
									)}
								</tbody>
							</table>
						</div>
					</div>
					:
					<></>
				}
			</div>
			{isValid ?
				<div className='btn_container flex gap-2 justify-center mt-2'>
					<button onClick={save} className='comm_btn bg_ho_primary'>저장</button>
					{j001andj002 &&
						<button onClick={() => returnPage('list')} className='comm_btn_w'>목록</button>
					}
				</div>
				: <></>}
		</Main>
	)
}

export default OrgParticipate;